import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import './i18n'; // Import the i18n configuration
import AppRouter from './pages';
import { store } from './store';

 // Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <LanguageProvider>
              <AppRouter />
            </LanguageProvider>
        </QueryClientProvider>
      </Provider>
      <ToastContainer />
    </>
  );
}

export default App;
